export const DYING_STATES = ['78C6CC42-BCCE-4F22-9FC5-41F8D7E70944', 'EE063289-1AF3-41CF-B73C-64A0556E6D07', '2EAAA2E8-1B9C-196D-3E58-C29C09FF8492'];
export const RECOVERY_STATES = ['611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64', '553734EC-33D3-4527-AB2E-EF48ACED8DF0', '9AA7588A-4575-9550-343D-6ADB0C74C17F'];
export const UNCONSCIOUS_STATUS_ID = 'F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1';
export const DEATH_STATE_SOURCE_IDS = [...DYING_STATES, ...RECOVERY_STATES, UNCONSCIOUS_STATUS_ID];
export const DEAD_STATUS_ID = '9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA';
export const HASTED_STATUS_ID = '091B2BEE-7F61-D7DB-0CF1-6D255F4B7663';
export const STUNNED_STATUS_ID = 'D218F4FB-5693-87B9-93C1-776FC1F7ED90';
